"use client";
import React from "react";
import { usePathname } from "next/navigation";
import { useRouter } from "next13-progressbar";
import Link from "next/link";
import { IoArrowBack } from "react-icons/io5";

const Breadcrumb = ({
  homeElement,
  separator,
  capitalizeLinks,
  pathNames = [],
}) => {
  const paths = usePathname();
  const router = useRouter();
  if (pathNames.length === 0)
    pathNames = paths.split("/").filter((path) => path);

  const containerClases = "flex flex-row gap-2 text-sm";
  const listClasses = "hover:text-blue-900";
  const activeClasses = "text-blue-900 font-bold";

  const handleClick = () => {
    router.back();
  };

  return (
    <div className="flex flex-col items-start justify-start gap-2 my-5">
      <div
        className=" flex flex-row justify-center items-center gap-2 hover:cursor-pointer hover:text-blue-900 hover:font-bold"
        onClick={handleClick}
      >
        <IoArrowBack />
        <span>Regresar </span>
      </div>
      <ul className={containerClases}>
        <li className={listClasses}>
          <Link href={"/"}>{homeElement}</Link>
        </li>
        {pathNames.length > 0 && separator}
        {pathNames.map((link, index) => {
          let href = `/${pathNames.slice(0, index + 1).join("/")}`;
          let itemClasses =
            paths === href ? `${listClasses} ${activeClasses}` : listClasses;
          let itemLink = capitalizeLinks
            ? link[0].toUpperCase() + link.slice(1, link.length)
            : link;
          return (
            <React.Fragment key={index}>
              <li className={itemClasses}>
                <Link href={href}>{itemLink}</Link>
              </li>
              {pathNames.length !== index + 1 && separator}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default Breadcrumb;
